import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {
  formatBookDetailUrl,
  startCase
} from '../../helpers/Helper';
import slugify from 'slugify';
import Link from 'next/link';
import { useAppContext } from '@components/Provider';
import NextImage from '@components/Image/NextImage';
import FollowButton from '@components/FollowButton/FollowButton';

import styles from "./AuthorCard.module.css";

const renderImage = (props) => {
  let image = props.author.Image ? props.author.Image : 'https://orion-uploads.openroadmedia.com/frontend-assets/no-contributor-image.png',
    linkClass = '';

  if (props.allowLinks) {
    linkClass = 'allowLink';
  }
  return (
    <div className={"author-image "} >
      <Link href={`/contributor/${props.author.Slug}`} >
        <NextImage ImageUrl={image && image ? image : ''} width={235} height={235} Title={props.author.Display_Name} Alt_Text={props.author.Display_Name} className="linkClass authorLinkImage" />
        {props.showRemoveButton ? showRemoveBtn(props) : null}
      </Link>
    </div>
  );
}

const renderBooks = (props) => {
  return props.author.Books.map((book, key) => {
    let linkClass = '',
      number = key + 1 + '. ';

    if (props.allowLinks) {
      linkClass = 'allowLink';
      number = '';
    }

    return (
      <div key={key} className={[styles["author-books"], linkClass].join(" ")}>
        <Link href={formatBookDetailUrl(book.Primary_ISBN, slugify(book.Title))}>
          <span>{number}</span><span>{book.Title}</span>
        </Link>
      </div>
    );
  });
}

const showRemoveBtn = (props) => {
  return (
    <Button
      classes='button'
      handleClick={() => props.handleRemove()}
      text={"remove slide"}
    />
  )
}

const renderListHeader = () => {
  return (
    <div className={styles["author-booklist-header"]}>
      Bestsellers
    </div>
  )
}

const renderFollowButton = (props, isMobile) => {
  if (props.author) {
    return (
      <FollowButton 
      eventName="clickFollow-HomePage" 
      author={props.author.Display_Name} 
      authorId={props.author.Firebrand_ID} 
      icon={true} classes="authorFollow" 
      setOpen={props.setOpen} 
      setAuthor={props.setAuthor} 
      setAuthorId={props.setAuthorId} 
      fromSlider={true} 
      isMobile = {isMobile}/>
    )
  }
}


const AuthorCard = (props) => {
  const { isMobile } = useAppContext();
  const {
    displayName = "AuthorCard",
    showRemoveButton = true,
    showListHeader = false,
    allowLinks = true
  } = props;

  let author = props.author,
    name = author.Display_Name ? author.Display_Name : '',
    books = author.Books ? renderBooks({...props, allowLinks}) : null,
    showlistHeader = showListHeader ? renderListHeader(props) : null,
    linkClass = '';

  if (allowLinks) {
    linkClass = 'allowLink';
  }
  return (
    <div className={displayName}>
      <div className={styles["AuthorCardContent"]}>
      {useMemo(()=>renderImage({...props, showRemoveButton, allowLinks}),[])}
      <div className={styles["author-details"]}>
        <div className={[styles["author-name"], linkClass].join(" ")}>
          <Link href={`/contributor/${props.author.Slug}`}>
            {startCase(name)}
          </Link>
        </div>
        {useMemo(()=>renderFollowButton(props, isMobile),[])}
        {showlistHeader}
        {books}
        </div>
        <style jsx global>{`
          .author-info-icon::after {
            top: calc(100% + 15px);
            left: -240px;
            width: 250px;
          }
          @media only screen and (min-device-width: 375px) and (max-device-width: 845px) and (orientation: landscape) {
            .author-info-icon::after {
              top: calc(100% + 15px);
              left: 240px;
            }
          }
        `}</style>
      </div>

    </div>
  );
}

export default AuthorCard;

AuthorCard.propTypes = {
  displayName: PropTypes.string,
  author: PropTypes.object.isRequired,
  handleRemove: PropTypes.func,
  classes: PropTypes.string,
  showRemoveButton: PropTypes.bool,
  showListHeader: PropTypes.bool,
  allowLinks: PropTypes.bool
}
